import YoungPersonBasicDetailsForm from './BasicDetails';
export default YoungPersonBasicDetailsForm;
